import React from 'react';
import PageHero from '../components/PageHero';
import { testimonials, heroImages } from '../mock';
import { Star, Quote } from 'lucide-react';
import { Link } from 'react-router-dom';

const caseStudies = [
  { brand: 'UrbanKart', metric: '3.2x', label: 'Sales in 6 months', color: '#1F8B4C' },
  { brand: 'Fashion Studio', metric: '85%', label: 'Increase in orders', color: '#FF7A00' },
  { brand: 'HomeDecor Pvt Ltd', metric: '12k+', label: 'Instagram followers', color: '#146638' },
  { brand: 'Crafts India', metric: '40+', label: 'Countries reached', color: '#FF7A00' },
];

const cardBg = [
  'linear-gradient(135deg, #E8F5EE 0%, #ffffff 100%)',
  'linear-gradient(135deg, #FFF7EE 0%, #ffffff 100%)',
  'linear-gradient(135deg, #FFF3D6 0%, #ffffff 100%)',
];

export default function TestimonialsPage() {
  return (
    <>
      <PageHero
        eyebrow="Testimonials"
        title="Loved by Growing Brands"
        sub="Real stories from real merchants who scaled their business with EC SAFETRADE SOLUTIONS."
        image={heroImages.happyOwner}
        accent="orange"
      />

      <section className="section bg-white">
        <div className="container-x">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="card-hover rounded-2xl p-7 border border-neutral-100 shadow-sm relative"
                style={{ background: cardBg[i % cardBg.length] }}
              >
                <Quote size={32} className="text-[color:var(--brand-green)]/70 mb-3" />
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} size={16} fill="#FFB629" stroke="#FFB629" />
                  ))}
                </div>
                <p className="text-[color:var(--ink)] leading-relaxed">&ldquo;{t.text}&rdquo;</p>
                <div className="mt-6 pt-4 border-t border-neutral-200 flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-[color:var(--brand-green)] text-white font-bold flex items-center justify-center">
                    {t.name.split(' ').map((n) => n[0]).join('').slice(0, 2)}
                  </div>
                  <div>
                    <div className="font-bold text-sm text-[color:var(--ink)]">{t.name}</div>
                    <div className="text-xs text-[color:var(--ink-soft)]">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[color:var(--brand-green-light)]/40">
        <div className="container-x">
          <div className="text-center mb-12">
            <div className="eyebrow">Impact in Numbers</div>
            <h2 className="section-title mt-3">Real Results, Real Growth</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {caseStudies.map((c) => (
              <div key={c.brand} className="bg-white rounded-2xl p-7 shadow-md border border-neutral-100 text-center relative overflow-hidden card-hover">
                <div
                  className="absolute top-0 left-0 right-0 h-1"
                  style={{ background: c.color }}
                />
                <div className="text-4xl font-black" style={{ color: c.color }}>{c.metric}</div>
                <div className="text-xs font-semibold uppercase tracking-wider text-[color:var(--ink-soft)] mt-1">{c.label}</div>
                <div className="text-sm text-[color:var(--ink)] font-bold mt-3">{c.brand}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-r from-[color:var(--brand-green)] to-[color:var(--brand-green-dark)] text-white text-center">
        <div className="container-x">
          <h2 className="text-3xl md:text-4xl font-black">Be our next success story</h2>
          <p className="mt-3 text-white/85">Join 30,000+ merchants growing with EC Safetrade Solutions.</p>
          <Link to="/contact" className="btn-orange mt-6 inline-flex">Start Your Growth Journey</Link>
        </div>
      </section>
    </>
  );
}
